<template>
  <sp-container-breakpoints
    v-if="hasBreakpoints"
    :class="className"
    :width-breakpoints="props.widthBreakpoints"
    :height-breakpoints="props.heightBreakpoints"
  >
    <slot />
  </sp-container-breakpoints>
  <div v-else :class="className">
    <slot />
  </div>
</template>
<script setup>
import { defineProps, computed } from "vue";
const props = defineProps({
  widthBreakpoints: {
    type: String,
    default: undefined,
  },
  heightBreakpoints: {
    type: String,
    default: undefined,
  },
});

const hasBreakpoints = computed(() => props.widthBreakpoints || props.heightBreakpoints);
const className = "tile-grid";
</script>
<style lang="scss" scoped>
.tile-grid {
  display: grid;
  grid-template-columns: repeat(var(--sp-dtv-tile-grid-columns, auto-fit), minmax(20ch, 1fr));
  gap: var(--sp-dtv-tile-grid-gap, 0.75rem);
}
</style>
